/* eslint-disable max-len */
export default {
  header: '',
  item: `<label class="{{cssClasses.label}}">
  <input type="radio" class="{{cssClasses.radio}}" name="{{attributeName}}" {{#isRefined}}checked{{/isRefined}} />{{name}}
</label>`,
  footer: '',
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/widgets/numeric-refinement-list/defaultTemplates.js